import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/agents')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Estate agents</h1>
      <EmptyState
        title="Estate agents"
        description="Agent, agency and referral counts arrive with the agents feature."
      />
    </div>
  );
}
